import React from "react";
import GoogleMapReact from "google-map-react";

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default function SimpleMap() {
  const defaultProps = {
    center: {
      lat: 10.99835602,
      lng: 77.01502627,
    },
    zoom: 11,
  };

  // AIzaSyDoTwS6tKPMdsDp0Mg2KQEhM_YOuBFgnX0

  return (
    // Important! Always set the container height explicitly
    <div style={{ height: "528px", width: "90%" }} className="maplocation">
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyDoTwS6tKPMdsDp0Mg2KQEhM_YOuBFgnX0" }}
        defaultCenter={{ lat: 27.1920089 , lng:31.1861429}}
        defaultZoom={16}
      >
        <AnyReactComponent  lat={ 27.1920089} lng={31.1861429} text={<i class="fas fa-map-marker-alt mapmarkeronMap"></i>} />
      </GoogleMapReact>
    </div>
  );
}
